@if (courseDto && contactDetailsForm) {
  <div class="ontario-row">
    @if (!isCreateMode || isCreateMode || canUpdateFields) {
      <h1 class="page-title">
        {{(isCompleted ? 'ClassEnrolment.LearnerDetails' : isCreateMode ? 'CreateClassroom.CreateEnrolment' :
        'ClassEnrolment.EnrolmentRequest') | translate}}
        @if (status) {
          <label class="status-enrolled-badge" [class.pending]="status == 'pending'"
            [class.cancelled]="status =='cancelled'">
            {{('ClassEnrolment.' + status[0].toUpperCase() + status.substring(1)) | translate}}
          </label>
        }
        @if (!isCreateMode) {
          <span class="updated-text">
            {{'ClassEnrolment.Updated' | translate}}: {{globalUpdateDate | date : 'MMM dd, yyyy'}}
          </span>
        }
      </h1>
      <div class="sub-header">
        <span>{{currentLang == 'en' ? courseDto.ProgramFullName : courseDto.ProgramFullNameFr}}</span>
        <span class="display-id">{{courseDto.ProgramDisplayId}}</span>
      </div>
      <div class="ontario-margin-top-32-! sub-header-mobile">
        <h2 class="border-bottom">{{'ClassEnrolment.CourseEnrolmentRequest' | translate}}</h2>
      </div>
    }
    <div class="page-content-with-right-sidebar ontario-row ontario-margin-top-24-!">
      <div class="training-schedule-div ontario-column ontario-padding-left-0-!"
        [ngClass]="!isCreateMode && !canUpdateFields ? 'ontario-medium-12 ontario-padding-right-0-!' : 'main-content'">
        @if (isCreateMode || canUpdateFields) {
          @if (!canUpdateFields && !isCreateMode) {
            <h1 class="border-bottom">{{'ClassEnrolment.EnrolmentRequest' |
            translate}}</h1>
          }
          <div [class.ontario-margin-top-24-!]="!canUpdateFields && !isCreateMode">
            @if (!canUpdateFields || !isTP) {
              <app-horizontal-radio-button-list [radioButtonOptions]="enrolRequestOptions"
                [label]="'ClassEnrolment.EnrolmentRequestType' | translate" [currentLang]="currentLang"
                (valueChange)="setSingleOrMultiOption($event)" [value]="singleOrMultiOption" [isDisabled]="isWorker">
              </app-horizontal-radio-button-list>
            }
            @if (canUpdateFields && isTP) {
              <label class="answer-text">{{getEnrolmentRequestType()}}</label>
            }
          </div>
          <div class="ontario-margin-top-24-! ">
            @if (!canUpdateFields  || !isTP) {
              <app-horizontal-radio-button-list [radioButtonOptions]="enrolOptions"
                [label]="'ClassEnrolment.EnrolmentRequestFor' | translate" [currentLang]="currentLang"
                (valueChange)="setEnrolRequestForOption($event)" [value]="selectedEnrolRequestForOption"
                [isDisabled]="isWorker">
              </app-horizontal-radio-button-list>
            }
            @if (canUpdateFields && isTP) {
              <label class="answer-text">{{getEnrolmentRequestFor()}}</label>
            }
            @if (singleOrMultiOption === '2' && isCreateMode && !([ENROLLMENT_FLOW_TYPE.EnrolledEditForPrimaryContact, ENROLLMENT_FLOW_TYPE.EnrolledEditForLearner].includes(enrollmentFlowType))) {
              <div class="ontario-row box number-box"
                >
                <div class="ontario-column ontario-small-12 ontario-medium-12 ontario-large-12">
                  <app-numeric-input [label]="getLabel()" [(value)]="noOfSeats" (valueChange)="CreateSeats($event, true)"
                  [min]="minNoOfSeats" [max]="maxNoOfSeats"></app-numeric-input>
                </div>
              </div>
            }
          </div>
          <!-- Multi Enrol banners -->
          @if (!isTP) {
            <div class="alert-box-top-margin-only ontario-small-12 ontario-large-10 ontario-medium-10">
              <app-alert-banner bannerType="alert"
              [bannerText]="translateService.instant('ClassEnrolment.NoticeOfCollection')"></app-alert-banner>
            </div>
          }
          <div class="alert-box-top-margin-only ontario-small-12 ontario-large-10 ontario-medium-10">
            <app-alert-banner bannerType="warning"
            [bannerText]="translateService.instant('ClassEnrolment.UniqueEmailRequirement')"></app-alert-banner>
          </div>
        }
        @if (!isCreateMode && !canUpdateFields) {
          <app-enrolement-summary [groupOrRegIdInput]="groupOrRegId" [isTP]="isTP"
            [updatedPending]="updatedPending" [updatedConfirmed]="updatedConfirmed" [status]="status"
            (learnerSelectedOutput)="selectLearner($event)"
          (enrolmentGroupId)="setEnrolmentGroupId($event)"></app-enrolement-summary>
        }
        @if (isCreateMode || canUpdateFields) {
          <!-- Single Enrol, Team Member banner -->
          <fieldset>
            @if ((singleOrMultiOption === '1' && selectedEnrolRequestForOption === '1') || [ENROLLMENT_FLOW_TYPE.EnrolledEditForLearner].includes(enrollmentFlowType)) {
              <div
                class="ontario-margin-top-32-! ontario-small-12 ontario-large-10 ontario-medium-10">
                <h3 class="border-bottom">
                  {{'ClassEnrolment.LearnerDetails' | translate}}
                </h3>
                <div>{{'General.MandatoryFields' | translate}}</div>
              </div>
            }
            <legend>
              @if (!((![ENROLLMENT_FLOW_TYPE.EnrolledEditForLearner].includes(enrollmentFlowType)) && (selectedEnrolRequestForOption === '2' || singleOrMultiOption === '2')
                || ([ENROLLMENT_FLOW_TYPE.EnrolledEditForPrimaryContact].includes(enrollmentFlowType)))) {
                <span class="screen-reader-only"
                  >{{'ClassEnrolment.LearnerDetails' |
                translate}}</span>
              }
              @if ((![ENROLLMENT_FLOW_TYPE.EnrolledEditForLearner].includes(enrollmentFlowType)) && (selectedEnrolRequestForOption === '2' || singleOrMultiOption === '2')
                || ([ENROLLMENT_FLOW_TYPE.EnrolledEditForPrimaryContact].includes(enrollmentFlowType))) {
                <span class="screen-reader-only"
                  >{{'ClassEnrolment.PrimaryContact' |
                translate}}</span>
              }
            </legend>
            @if (singleOrMultiOption === '1' && selectedEnrolRequestForOption === '1') {
              <div
                class="alert-box-top-margin-only ontario-small-12 ontario-large-10 ontario-medium-10">
                <app-alert-banner [bannerType]="isTP ? 'alert' : 'warning'"
                  [bannerText]="translateService.instant(isTP ? 'ClassEnrolment.LearnerRecordPrivacy' :(isLearnerDetailEmpty ? 'ClassEnrolment.LearnerContactDetails' : 'Worker.LearnerProfileDetailsBanner'))">
                </app-alert-banner>
              </div>
            }
            @if ((![ENROLLMENT_FLOW_TYPE.EnrolledEditForLearner].includes(enrollmentFlowType)) && (selectedEnrolRequestForOption === '2' || singleOrMultiOption === '2')
              || ([ENROLLMENT_FLOW_TYPE.EnrolledEditForPrimaryContact].includes(enrollmentFlowType))) {
              <div
                class="ontario-margin-top-48-! ontario-small-12 ontario-large-10 ontario-medium-10">
                <h3 class="border-bottom">
                  {{'ClassEnrolment.PrimaryContact' | translate}}
                </h3>
                @if (isCreateMode || canUpdateFields) {
                  <span>
                    {{'ClassEnrolment.PleaseProvideYourContactDetails' | translate }}
                  </span>
                }
                <div>{{'General.MandatoryFields' | translate}}</div>
              </div>
            }
            <!-- Primary Contact or Self -->
            <div class="content">
              @if (contactDetailsForm) {
                <div [formGroup]="contactDetailsForm">
                  <div class="field ontario-small-12 ontario-large-4">
                    <mat-label class="input-label">
                      <span class="required-field">
                        {{(singleOrMultiOption === '1' && selectedEnrolRequestForOption === '1' ?
                        'ClassEnrolment.EmailAddress' : 'ClassEnrolment.EmailAddress') | translate}}
                      </span>
                    </mat-label>
                    <input autocomplete="email" type="email" class='input-text' matInput formControlName="emailAddress"
                      required maxlength="320" [attr.aria-label]="'ClassEnrolment.EmailAddress' | translate"
                      (change)="updateMySelf()" placeholder="{{'Contact.EmailAddressTooltip' | translate}}" (blur)="validateTpUserEmail()" />
                      @if ((contactDetailsForm.controls['emailAddress'].invalid &&  contactDetailsForm.controls['emailAddress'].errors && (contactDetailsForm.controls['emailAddress'].dirty || contactDetailsForm.controls['emailAddress'].touched))) {
                        <div role="alert"
                          >
                          @if (contactDetailsForm.controls['emailAddress'].hasError('pattern')) {
                            <mat-error>
                              {{'Validation.Email.Pattern' | translate}}
                            </mat-error>
                          }
                          @if (contactDetailsForm.controls['emailAddress'].hasError('required')) {
                            <mat-error>
                              {{'Validation.Email.PoliteRequired' | translate}}
                            </mat-error>
                          }
                          @if (contactDetailsForm.controls['emailAddress'].hasError('exists')) {
                            <mat-error>
                              {{'CreateClassroom.Validation.EmailAddressExists' | translate}}
                            </mat-error>
                          }                          
                          @if (contactDetailsForm.controls['emailAddress'].hasError('currentTpUser')) {
                            <mat-error>
                              {{'CreateClassroom.Validation.CurrentTpUser' | translate}}
                            </mat-error>
                          }
                        </div>
                      }
                    </div>
                    <div class="field ontario-small-12 ontario-large-4">
                      <mat-label class="input-label">
                        <span class="required-field">{{'Contact.FirstName' | translate}}</span>
                      </mat-label>
                      <input autocomplete="given-name" type="text" class='input-text' matInput formControlName="firstName"
                        required maxlength="250" [attr.aria-label]="'Contact.FirstName' | translate" (change)="updateMySelf()"
                        placeholder="{{'Contact.FirstNameTooltip' | translate}}" />
                        @if ((contactDetailsForm.controls['firstName'].invalid &&  contactDetailsForm.controls['firstName'].errors && (contactDetailsForm.controls['firstName'].dirty || contactDetailsForm.controls['firstName'].touched))) {
                          <div role="alert"
                            >
                            @if (contactDetailsForm.controls['firstName'].hasError('required')) {
                              <mat-error>
                                {{'Validation.FirstName.Required' | translate}}
                              </mat-error>
                            }
                            @if (contactDetailsForm.controls['firstName'].hasError('maxlength')) {
                              <mat-error>
                                {{'Validation.FirstName.MaxLength' | translate}}
                              </mat-error>
                            }
                          </div>
                        }
                      </div>
                      <div class="field ontario-small-12 ontario-large-4">
                        <mat-label class="input-label">
                          <span class="required-field">{{'Contact.LastName' | translate}}</span>
                        </mat-label>
                        <input autocomplete="family-name" type="text" class='input-text' matInput formControlName="lastName"
                          required maxlength="250" [attr.aria-label]="'Contact.LastName' | translate" (change)="updateMySelf()"
                          placeholder="{{'Contact.LastNameTooltip' | translate}}" />
                          @if ((contactDetailsForm.controls['lastName'].invalid &&  contactDetailsForm.controls['lastName'].errors && (contactDetailsForm.controls['lastName'].dirty || contactDetailsForm.controls['lastName'].touched))) {
                            <div role="alert"
                              >
                              @if (contactDetailsForm.controls['lastName'].hasError('required')) {
                                <mat-error>
                                  {{'Validation.LastName.Required' | translate}}
                                </mat-error>
                              }
                              @if (contactDetailsForm.controls['lastName'].hasError('maxlength')) {
                                <mat-error>
                                  {{'Validation.LastName.MaxLength' | translate}}
                                </mat-error>
                              }
                            </div>
                          }
                        </div>
                        <div class="field ontario-small-12 ontario-large-4">
                          <mat-label class="input-label">
                            <span class="required-field">{{'ClassEnrolment.Phone' | translate}}</span>
                          </mat-label>
                          <input autocomplete="tel" type="text" mask="000-000-0000" class='input-text' matInput
                            formControlName="phone" required [attr.aria-label]="'ClassEnrolment.Phone' | translate"
                            (change)="updateMySelf()" placeholder="{{'Contact.PhoneTooltip' | translate}}" />
                            @if ((contactDetailsForm.controls['phone'].invalid &&  contactDetailsForm.controls['phone'].errors && (contactDetailsForm.controls['phone'].dirty || contactDetailsForm.controls['phone'].touched))) {
                              <div role="alert"
                                >
                                @if (contactDetailsForm.controls['phone'].hasError('pattern')) {
                                  <mat-error>
                                    {{'Validation.Phone.Pattern' | translate}}
                                  </mat-error>
                                }
                                @if (contactDetailsForm.controls['phone'].hasError('required')) {
                                  <mat-error>
                                    {{'Validation.Phone.PoliteRequired' | translate}}
                                  </mat-error>
                                }
                              </div>
                            }
                          </div>
                          @if (singleOrMultiOption === '1' && contactDetailsForm.controls['birthYear']) {
                            <div class="field ontario-small-12 ontario-large-4"
                              >
                              <mat-label class="input-label">
                                <span class="required-field">{{'ClassEnrolment.BirthYear' | translate}}</span>
                              </mat-label>
                              <input autocomplete="bday-year" type="text" mask="0000" class='input-text' matInput
                                formControlName="birthYear" required [attr.aria-label]="'ClassEnrolment.BirthYear' | translate"
                                maxlength="4" placeholder="{{'ClassEnrolment.EnterBirthYear' | translate}}" />
                                @if ((contactDetailsForm.controls['birthYear'].invalid &&  contactDetailsForm.controls['birthYear'].errors && (contactDetailsForm.controls['birthYear'].dirty || contactDetailsForm.controls['birthYear'].touched))) {
                                  <div role="alert"
                                    >
                                    <mat-error>
                                      {{'Validation.BirthYear.Pattern' | translate}}
                                    </mat-error>
                                  </div>
                                }
                              </div>
                            }
                            @if (contactDetailsForm.controls['employeeName']) {
                              <div class="field ontario-small-12 ontario-large-4">
                                <mat-label class="input-label"><span>{{'ClassEnrolment.EmployeeName' | translate}}</span></mat-label>
                                <input type="text" class='input-text' matInput formControlName="employeeName"
                                  [attr.aria-label]="'ClassEnrolment.EmployeeName' | translate"
                                  placeholder="{{'ClassEnrolment.EmployeeNameTooltip' | translate}}" />
                                </div>
                              }
                              @if (contactDetailsForm.controls['note']) {
                                <div class="field ontario-small-12 ontario-large-6">
                                  <div class="message-box">
                                    <mat-label class="input-label">
                                      <span>{{'ClassEnrolment.Note' | translate}}</span>
                                    </mat-label>
                                    <div class="message-input">
                                      <textarea class='input-text' matInput formControlName="note"
                                        placeholder="{{'ClassEnrolment.EnterNote' | translate}}"
                                      [attr.aria-label]="'ClassEnrolment.Note' | translate"></textarea>
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      </fieldset>
                    }
                    <!--commenting below lines as it seems duplicate condition of extra learners section-->
                    <!-- <div *ngIf="canUpdateFields && singleOrMultiOption == '1' && selectedEnrolRequestForOption == '2'">
                    <div class="ontario-margin-top-48-! ontario-small-12 ontario-large-10 ontario-medium-10">
                      <h3 class="border-bottom">
                        {{'ClassEnrolment.LearnerDetails' | translate}}
                      </h3>
                    </div>
                    <div class="alert-box-top-margin-only ontario-small-12 ontario-large-10 ontario-medium-10">
                      <app-alert-banner [bannerType]="isTP ? 'alert' : 'warning'" [bannerText]="translateService.instant(isTP ? 'ClassEnrolment.LearnerRecordPrivacy' :'ClassEnrolment.LearnerContactDetails')">
                      </app-alert-banner>
                    </div>
                  </div> -->
                  <!-- extra learners -->
                  @if (learnerDetails && (learnerDetails.length > 0 || singleOrMultiOption == '2' || (canUpdateFields && singleOrMultiOption == '1' && selectedEnrolRequestForOption == '2'))) {
                    @if (isCreateMode || canUpdateFields && (!isTP || !canUpdateFields)) {
                      <div class="ontario-margin-top-48-! ontario-small-12 ontario-large-10 ontario-medium-10">
                        <h3 class="border-bottom">{{'ClassEnrolment.LearnerDetails' | translate}}</h3>
                      </div>
                      <div>{{'General.MandatoryFields' | translate}}</div>
                      <div class="alert-box-top-margin-only ontario-small-12 ontario-large-10 ontario-medium-10">
                        <app-alert-banner bannerType="warning"
                        [bannerText]="translateService.instant('ClassEnrolment.WorkerorLearnerContactDetails')"></app-alert-banner>
                      </div>
                    }
                    @if (!([ENROLLMENT_FLOW_TYPE.EnrolledEditForPrimaryContact,ENROLLMENT_FLOW_TYPE.EnrolledEditForLearner].includes(enrollmentFlowType))) {
                      <div
                        class="training-schedule-div ontario-column ontario-small-12 ontario-margin-bottom-24-! ontario-large-10 ontario-padding-left-0-!"
                        [ngClass]="!isCreateMode && !canUpdateFields ? 'ontario-medium-8' : 'ontario-medium-10'">
                        @for (ld of learnerDetails; track ld; let i = $index) {
                          <div
                            [ngClass]="!isCreateMode && !canUpdateFields ? 'ontario-column ontario-small-12 ontario-large-12 ontario-medium-8 ontario-margin-bottom-8-! float-left' : ''">
                            @if ((isTP && !canUpdateFields && isCreateMode) || (isTP && canUpdateFields && (learnerDetails.length > 1
                              || (singleOrMultiOption == '2')
                              || (canUpdateFields && singleOrMultiOption == '1' && selectedEnrolRequestForOption == '2'))) || (!isTP && (isCreateMode || canUpdateFields
                              || (!isCreateMode && ld.registrationId == null)))) {
                              <app-learner-detail #learnerDetails [learnerDetail]="ld"
                                #learnerDetail [isTPEdit]="isTP && (canUpdateFields || isCreateMode)"
                                [disableDelete]="i < 2 || (isTP && isCreateMode)" [singleTeamMember]="singleOrMultiOption == '1'"
                                [courseDto]="courseDto" [learnerNumber]="i" (deleteLearner)="DeleteLearner($event)"
                                [learnerInforRequired]="isLearnerInfoRequired(i)"
                                [DisableSameAsPrimaryContact]="!contactDetailsForm!.valid" [courseId]="courseId"
                                [isTP]="isTP" [currentTpUserEmail]="currentTpUserEmail"
                                [showEligibilityChecker]="isCreateMode && !isTP" (validateEmailExists)="validateLearnerEmail(i);"
                              (copyInfoFromPrimaryContact)="PastePrimaryContactInfoInChildComponent()"></app-learner-detail>
                            }
                          </div>
                        }
                      </div>
                    }
                    @if (!groupOrRegId && !isTP) {
                      <div class="alert-box ontario-small-12 ontario-large-10 ontario-medium-10">
                        <app-alert-banner bannerType="alert"
                        [bannerText]="translateService.instant('ClassEnrolment.LearnersRecordPrivacy')"></app-alert-banner>
                      </div>
                    }
                  }
                  @if (isCreateMode && !isTP && !isWorker) {
                    <div class="ontario-column ontario-small-12 ontario-large-10 ontario-padding-left-0-!"
                      >
                      @if (singleOrMultiOption == '1' && selectedEnrolRequestForOption == '1') {
                        <app-eligibility-checker [isSingleTeamMember]="singleOrMultiOption == '1'" #elig
                        [courseDto]="courseDto"></app-eligibility-checker>
                      }
                    </div>
                  }
                  @if (!([ENROLLMENT_FLOW_TYPE.EnrolledEditForPrimaryContact,ENROLLMENT_FLOW_TYPE.EnrolledEditForLearner].includes(enrollmentFlowType))) {
                    <div class="ontario-column ontario-small-12 ontario-large-10 ontario-padding-left-0-!"
                      >
                      @if (isTP && canUpdateFields && singleOrMultiOption == '2') {
                        <button
                          (click)="CreateSeats(learnerDetails.length+1)"
                          class="ontario-button black-button ontario-margin-top-0-! add-learner">
                          {{'ClassEnrolment.AddLearner' | translate}}
                        </button>
                      }
                    </div>
                  }
                  @if (isCreateMode && !isTP) {
                    <div
                      class="ontario-column ontario-small-12 ontario-large-10 ontario-medium-10 ontario-padding-left-0-!">
                      @if (contactDetailsForm.controls['optInForEmail']) {
                        <div class="enrolment-confirmation-box ontario-margin-bottom-48-!"
                          >
                          <fieldset>
                            <legend>
                              <div class="heading">
                                <h4 class="border-bottom ontario-margin-bottom-24-!">{{'Contact.Subscription' | translate}}</h4>
                              </div>
                            </legend>
                            <div class="confirmation-checkbox ontario-margin-bottom-12-!">
                              <app-checkbox [name]="'ClassEnrolment.OptInForEmail' | translate"
                                [checked]="contactDetailsForm.controls['optInForEmail'].value"
                                (checkedChange)="contactDetailsForm.controls['optInForEmail'].setValue($event);">
                              </app-checkbox>
                            </div>
                            <div class="confirmation-checkbox">
                              <app-checkbox [name]="'ClassEnrolment.OptInForText' | translate"
                                [checked]="contactDetailsForm.controls['optInForText'].value"
                                (checkedChange)="contactDetailsForm.controls['optInForText'].setValue($event);">
                              </app-checkbox>
                            </div>
                          </fieldset>
                        </div>
                      }
                    </div>
                  }
                  @if (isTP) {
                    <div class="ontario-column ontario-small-12 ontario-padding-left-0-!"
                      [class.up-2]="isCreateMode && isTP"
                      [class.up-3]="(isTP && !canUpdateFields && !isCreateMode && singleOrMultiOption == '2')"
                      [class.ontario-large-8]="isTP && !isCreateMode && !canUpdateFields"
                      [class.margin-up]="isTP && !isCreateMode && !canUpdateFields && !(isTP && !canUpdateFields && singleOrMultiOption == '2')">
                      @if (isSubscriptionVisible()) {
                        <app-enrolment-subscription
                        [Enrolment]="primaryContact"></app-enrolment-subscription>
                      }
                      @if (!isCreateMode && canUpdateFields && (singleOrMultiOption ==='1' && selectedEnrolRequestForOption == '1')) {
                        <div
                          class="field ontario-margin-bottom-48-! border-bottom ontario-margin-top-32-!">
                          <mat-label class="input-label">{{'ClassEnrolment.SubmittedOn' | translate}}</mat-label>
                          <label class="answer-text">
                            {{globalCreateDate | utcToLocalDateTime : 'MMM dd, yyyy'}} {{'General.At' | translate}}
                            {{globalCreateDate | utcToLocalDateTime : 'hh:mm aa'}}
                          </label>
                        </div>
                      }
                      @if ((!isCompleted && !([ENROLLMENT_FLOW_TYPE.EnrolledEditForLearner].includes(enrollmentFlowType))) || ([ENROLLMENT_FLOW_TYPE.EnrolledEditForPrimaryContact].includes(enrollmentFlowType))) {
                        <app-administrative-work
                          [Enrolment]="primaryContact" [isEditMode]="isCreateMode || canUpdateFields"
                          (adminWorkUpdated)="adminWorkOrMessageChanged($event)"
                        [showEligibility]="courseDto.TrainingProgramId==tpAppUtils.JHSC2 || courseDto.TrainingProgramId==tpAppUtils.JHSCR || courseDto.TrainingProgramId==tpAppUtils.WAHRefresher"></app-administrative-work>
                      }
                      @if ((!isCompleted && !([ENROLLMENT_FLOW_TYPE.EnrolledEditForLearner].includes(enrollmentFlowType))) || ([ENROLLMENT_FLOW_TYPE.EnrolledEditForPrimaryContact].includes(enrollmentFlowType))) {
                        <app-enrolment-confirmation
                          [Enrolment]="primaryContact" [isEditMode]="isCreateMode || canUpdateFields"
                          (messageUpdated)="adminWorkOrMessageChanged($event)"
                          [Email]="contactDetailsForm && contactDetailsForm.controls['emailAddress'] && contactDetailsForm.controls['emailAddress'].valid ? contactDetailsForm.controls['emailAddress'].value : ('ClassEnrolment.TheProvidedEmailAddress' | translate)">
                        </app-enrolment-confirmation>
                      }
                      <!--<app-record-of-completion *ngIf="isCompleted && canAccess()" [Enrolment]="primaryContact"></app-record-of-completion>
                      <div class="horizontal-rule"></div>-->
                    </div>
                  }
                  @if (isCreateMode && !isTP) {
                    <div
                      class="action-buttons ontario-margin-bottom-24-! border-top border-bottom ontario-padding-bottom-24-! ontario-column">
                      <button class="grey-button" (click)="backToCourseSearch()">
                        {{'General.Cancel' | translate}}
                      </button>
                      <button class="blue-button" [class.disabled]="DisableSubmitButton()" [disabled]="DisableSubmitButton()" (click)="saveEnrollment()">
                        {{'ClassEnrolment.SubmitEnrolmentRequest' | translate}}
                      </button>
                    </div>
                  }
                  @if (isCreateMode && !isTP) {
                    <div
                      class="ontario-column ontario-small-12 ontario-padding-bottom-48-! card-footer">
                      <div class="ontario-column ontario-small-4 separartor" (click)="backToCourseSearch()">
                        {{'General.Cancel' | translate}}
                      </div>
                      <div class="ontario-column ontario-small-8 no-right-padding strong-font"
                        [class.disabled]="DisableSubmitButton()" [attr.aria-disabled]="DisableSubmitButton()" (click)="DisableSubmitButton() ? null : saveEnrollment()">
                        {{'ClassEnrolment.SubmitEnrolmentRequest' | translate}}
                      </div>
                    </div>
                  }
                </div>
                <div class="ontario-column border-bottom mobile-divider"></div>
                <!--course details start -->
                @if (!groupOrRegId || canUpdateFields) {
                  <div class="right-sidebar">
                    <div class="grey-box">
                      <h4 class="border-bottom">{{'ClassEnrolment.CourseDetailsTitle' | translate}}</h4>
                      <div class="review-row">
                        <label class="question-text">
                          {{'ClassEnrolment.ProgramName' | translate}}
                        </label>
                        <label class="answer-text">
                          <b>{{currentLang == 'en' ? courseDto.ProgramFullName : courseDto.ProgramFullNameFr}}</b>
                        </label>
                      </div>
                      <div class="review-row">
                        <label class="question-text">
                          {{'ClassEnrolment.TrainingProvider' | translate}}
                        </label>
                        <label class="answer-text"><b>{{courseDto.TrainingProviderName}}</b></label>
                      </div>
                      @if (courseDto.AddressLine) {
                        <div class="review-row">
                          <label class="question-text">
                            {{'ClassEnrolment.TrainingLocation' | translate}}
                          </label>
                          <label class="address-label"><b [innerHTML]="formatAddress()"></b></label>
                        </div>
                      }
                      <div class="review-row">
                        <label class="question-text">
                          {{'ClassEnrolment.ClassInformation' | translate}}
                        </label>
                        @for (class of courseDto.ClassTimes; track class) {
                          <label class="answer-text">
                            <b>
                              {{getDate((class.ClassDate | utcToLocalDateTime), 'MMM dd - EEE')}} &#64; {{getTime(class.StartDate)}}
                              {{'General.To' | translate}} {{getTime(class.EndDate)}}
                            </b>
                          </label>
                        }
                        <label class="answer-text">
                          <b>
                            {{currentLang == 'en' ? courseDto.TrainingTypeName : courseDto.TrainingTypeNameFr}}
                          </b>
                        </label>
                      </div>
                      <div class="review-row">
                        <label class="question-text">
                          {{'ClassEnrolment.SeatsAvailable' | translate}}
                        </label>
                        <label
                          class="answer-text"><b>{{(courseDto.Capacity-courseDto.SeatsRegistered)}}/{{courseDto.Capacity}}</b></label>
                        </div>
                        <div class="review-row">
                          <label class="question-text">{{'ClassEnrolment.CourseFee' | translate}}</label>
                          <label class="answer-text">
                            @if (courseDto.Cost) {
                              <b>{{courseDto.Cost | currency}}</b>
                            }
                            @if (!courseDto.Cost) {
                              <b>{{'CreateClassroom.ContactTrainingProviderForPricing' | translate}}</b>
                            }
                          </label>
                        </div>
                        @if (courseDto.Email || courseDto.PhoneNumber || courseDto.Website) {
                          <div class="review-row">
                            <label class="question-text">{{'CreateNotification.Contact' | translate}}</label>
                            <label class="answer-text">
                              @if (courseDto.Email && courseDto.Email.ElectronicAddressValue) {
                                <b
                                >{{courseDto.Email.ElectronicAddressValue}}</b>
                              }
                            </label>
                            <label class="answer-text">
                              @if (courseDto.PhoneNumber && courseDto.PhoneNumber.ElectronicAddressValue) {
                                <b>{{courseDto.PhoneNumber.ElectronicAddressValue
                                | phone}}</b>
                              }
                            </label>
                            <label class="answer-text">
                              @if (courseDto.Website && courseDto.Website.ElectronicAddressValue) {
                                <b
                                >{{courseDto.Website.ElectronicAddressValue}}</b>
                              }
                            </label>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
            <div class="ontario-column border-bottom-thick mobile-divider"></div>
            @if ((courseDto && contactDetailsForm) && isTP) {
              <div class="bottom-bar">
                <div class="left-side">
                  @if (!canUpdateFields) {
                    <button class="grey-button" (click)="backToCourseSearch()">
                      {{'ClassEnrolment.BackToEnrolments' | translate}}
                    </button>
                  }
                  @if (canUpdateFields) {
                    <button class="grey-button" (click)="cancelEditing()">
                      {{'General.Cancel' | translate}}
                    </button>
                  }
                  <!-- Single Enrolment -->
                  @if (singleOrMultiOption == '1') {
                    @if (!canUpdateFields && courseWithEnrolments!=null
                      && (hasLearnerWithStatus(ENROLSTATUS.EnrolmentStatusConfirmed) || hasLearnerWithStatus(ENROLSTATUS.EnrolmentStatusPending))) {
                      <button class="link-button"
                        (click)="saveEnrollment(-1)">
                        {{'ClassEnrolment.CancelEnrolment' | translate}}
                      </button>
                    }
                    @if (!canUpdateFields && courseWithEnrolments!=null
                      && hasLearnerWithStatus(ENROLSTATUS.EnrolmentStatusConfirmed) && enrollmentFlowType != ENROLLMENT_FLOW_TYPE.PendingEdit) {
                      <button id="move-pending" class="float-right blue-button"
                        (click)="saveEnrollment(ENROLSTATUS.EnrolmentStatusPending)">
                        {{'ClassEnrolment.MoveToPending' | translate}}
                      </button>
                    }
                    @if (!canUpdateFields && hasLearnerWithStatus(ENROLSTATUS.EnrolmentStatusPending) || isCreateMode) {
                      <button class="float-right blue-button margin-left-30"
                        (click)="saveEnrollment(ENROLSTATUS.EnrolmentStatusConfirmed)"
                        [class.disabled]="(canUpdateFields || isCreateMode) ? (DisableSubmitButton()) : false"
                        [disabled]="(canUpdateFields || isCreateMode) ? DisableSubmitButton() : false"
                        [class.disabled]="(canUpdateFields || isCreateMode) ? (DisableSubmitButton()) : false">
                        {{'ClassEnrolment.ConfirmEnrolment' | translate}}
                      </button>
                    }
                    @if (isCreateMode || canUpdateFields) {
                      <button class="float-right black-button"
                        [class.disabled]="(canUpdateFields || isCreateMode) ? DisableSubmitButton() : false"
                        [disabled]="(canUpdateFields || isCreateMode) ? DisableSubmitButton() : false"
                        (click)="saveEnrollment(status === 'enrolled' ? 1 : 0 )">
                        {{ 'General.Save' | translate}}
                      </button>
                    }
                    @if (!canUpdateFields && !isCreateMode && status != 'cancelled' && !isCompleted) {
                      <button
                        class="float-right black-button" (click)="editEnrollment()">
                        {{ 'ClassEnrolment.EditEnrolment' | translate}}
                      </button>
                    }
                  }
                  <!-- Single Enrolment -->
                  <!-- Multiple Enrolment -->
                  @if (singleOrMultiOption == '2') {
                    @if (!canUpdateFields && courseWithEnrolments!=null
                      && (hasLearnerWithStatus(ENROLSTATUS.EnrolmentStatusConfirmed) || hasLearnerWithStatus(ENROLSTATUS.EnrolmentStatusPending))) {
                      <button class="link-button"
                        (click)="updateMultipleEnrollmentMyselfAndTeamMembers(-1, true)" [class.disabled]="NoSelectedLearners()" [disabled]="NoSelectedLearners()">
                        {{'ClassEnrolment.CancelEnrolment' | translate}}
                      </button>
                    }
                    @if (!canUpdateFields && courseWithEnrolments!=null
                      && hasLearnerWithStatus(ENROLSTATUS.EnrolmentStatusConfirmed) && enrollmentFlowType != ENROLLMENT_FLOW_TYPE.PendingEdit) {
                      <button id="move-pending" class="float-right blue-button"
                        (click)="updateMultipleEnrollmentMyselfAndTeamMembers(ENROLSTATUS.EnrolmentStatusPending,true)">
                        {{'ClassEnrolment.MoveToPending' | translate}}
                      </button>
                    }
                    @if (isCreateMode) {
                      <button class="float-right blue-button"
                        (click)="saveMultipleEnrollmentMyselfAndTeamMembers(ENROLSTATUS.EnrolmentStatusConfirmed)"
                        [disabled]="(canUpdateFields || isCreateMode) ? DisableSubmitButton() : false"
                        [class.disabled]="(canUpdateFields || isCreateMode) ? (DisableSubmitButton()) : false">
                        {{'ClassEnrolment.ConfirmEnrolment' | translate}}
                      </button>
                      <button class="float-right black-button"
                        [class.disabled]="(canUpdateFields || isCreateMode) ? DisableSubmitButton() : false"
                        [disabled]="(canUpdateFields || isCreateMode) ? DisableSubmitButton() : false"
                        (click)="saveMultipleEnrollmentMyselfAndTeamMembers(ENROLSTATUS.EnrolmentStatusPending)">
                        {{ 'General.Save' | translate}}
                      </button>
                    }
                    @if (!isCreateMode) {
                      @if (hasLearnerWithStatus(ENROLSTATUS.EnrolmentStatusPending) && !canUpdateFields) {
                        <button class="float-right blue-button"
                          [class.disabled]="NoSelectedLearners()"
                          [disabled]="NoSelectedLearners()"
                          (click)="updateMultipleEnrollmentMyselfAndTeamMembers(ENROLSTATUS.EnrolmentStatusConfirmed,true)">
                          {{'ClassEnrolment.ConfirmEnrolment' | translate}}
                        </button>
                      }
                      @if (canUpdateFields) {
                        <button class="float-right black-button"
                          [class.disabled]="(canUpdateFields || isCreateMode) ? DisableSubmitButton() : false"
                          [disabled]="(canUpdateFields || isCreateMode) ? DisableSubmitButton() : false"
                          (click)="updateMultipleEnrollmentMyselfAndTeamMembers(status === 'enrolled' ? 1 : 0)">
                          {{ 'General.Save' | translate}}
                        </button>
                      }
                    }
                    @if (!canUpdateFields && !isCreateMode && status != 'cancelled' && courseWithEnrolments!=null &&
                      (hasLearnerWithStatus(ENROLSTATUS.EnrolmentStatusPending) || (hasLearnerWithStatus(ENROLSTATUS.EnrolmentStatusConfirmed)))) {
                      <button
                        class="float-right black-button" (click)="editEnrollment()">
                        {{ 'ClassEnrolment.EditEnrolment' | translate}}
                      </button>
                    }
                  }
                  <!-- Multiple Enrolment -->
                </div>
              </div>
            }